import Handlebars from 'handlebars';

export default function() {
  const date = new Date();
  const dateUTC = new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  );

  return new Handlebars.SafeString(dateUTC.toLocaleString());
};
